module.exports = __webpack_public_path__ + "img/404.14595f3e.png";